import { createApp } from 'vue';
import { createPinia } from 'pinia';
import productSpecificationApp from '@/app/views/product-specification/product-specification.vue';
import { pushToDataLayer } from '@/js/analytics/analytics.methods';

// Product Specification & Related Product components share a Pinia state for metric/imperial system changes
export const productPagePinia = createPinia();
export default class productSpecification {
  constructor(el) {
    this.el = el;
    this.init();
  }
  init() {
    // Init Product Specs
    createApp(productSpecificationApp)
      .use(productPagePinia)
      .provide('config', JCB)
      .provide('gaPush', pushToDataLayer)
      .mount(this.el);
  }
}
